import React from "react";
import { getHistoryPresentation } from "../../utils/resultPresentation.js";

export default function AnalysisDiagnostic({ record }) {
  const { diagnostic, opposition } = getHistoryPresentation(record);
  if (!diagnostic && !opposition) return null;
  return <div className="d-flex flex-wrap gap-1 my-1" aria-label="Diagnostic de l’appel">
    {opposition && <span className="badge bg-danger">Opposition enregistrée</span>}
    {diagnostic && <span className={`badge bg-${diagnostic.tone} ${diagnostic.tone === "warning" ? "text-dark" : ""}`}>{diagnostic.label}</span>}
  </div>;
}
